<template>
        <KioskLogin v-if="this.$store.state.isKiosk"></KioskLogin>
        <div v-else-if="!this.$store.state.isKiosk" class="loginBox" style="display: none;">
            <svg style="position: absolute; width: 0; height: 0;" width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <symbol id="i_email" viewBox="0 0 409.602 307.199">
                        <path d="M358.398,0H51.199C22.926,0,0,22.926,0,51.199V256c0,28.273,22.926,51.199,51.199,51.199h307.199
		c28.278,0,51.204-22.926,51.204-51.199V51.199C409.602,22.926,386.676,0,358.398,0L358.398,0z M274.125,136.625L382.5,43.75
		c0.75,2.398,1.5,4.801,1.5,7.449V256c0,1.773-0.676,3.352-1.023,5.023L274.125,136.625z M358.398,25.602
		c1.704,0,3.204,0.648,4.801,0.972L204.801,162.352L46.398,26.574C48,26.25,49.5,25.602,51.199,25.602H358.398z M26.613,261
		c-0.351-1.676-1.011-3.227-1.011-5V51.199c0-2.648,0.761-5.051,1.511-7.449l108.336,92.852L26.613,261z M51.199,281.602
		c-2.586,0-4.937-0.754-7.301-1.477l111-126.852l41.579,35.625c2.386,2.079,5.359,3.102,8.324,3.102
		c2.961,0,5.937-1.023,8.324-3.102l41.574-35.625l111,126.852c-2.347,0.727-4.699,1.477-7.301,1.477H51.199z M51.199,281.602"/>
                    </symbol>
                    <symbol id="i_lock" viewBox="0 0 167.59 256">
                        <path d="M141.18,106.492V51.617C141.18,23.156,119.582,0,93.035,0h-18.48C48.008,0,26.41,23.156,26.41,51.617v54.875
		C10.164,122.281,0,144.676,0,169.477C0,217.188,37.59,256,83.793,256c46.207,0,83.797-38.812,83.797-86.523
		C167.59,144.676,157.426,122.281,141.18,106.492L141.18,106.492z M42.41,94.242V51.621C42.41,31.977,56.828,16,74.555,16h18.48
		c17.727,0,32.145,15.98,32.145,35.621v42.621c-2.184-1.281-4.422-2.449-6.703-3.519c-0.082-0.039-0.165-0.082-0.243-0.118
		c-0.32-0.148-0.64-0.293-0.964-0.437c-0.477-0.215-0.954-0.426-1.434-0.633c-0.227-0.097-0.453-0.191-0.68-0.285
		c-0.711-0.301-1.429-0.59-2.148-0.867c-0.016-0.008-0.035-0.012-0.047-0.02c-7.387-2.84-15.262-4.629-23.453-5.203
		c-0.188-0.012-0.379-0.023-0.57-0.035c-0.657-0.043-1.313-0.074-1.973-0.102c-0.219-0.007-0.434-0.019-0.653-0.023
		c-0.835-0.027-1.675-0.043-2.515-0.043c-0.844,0-1.684,0.016-2.52,0.043c-0.215,0.004-0.433,0.016-0.648,0.023
		c-0.66,0.028-1.32,0.059-1.977,0.102c-0.187,0.012-0.379,0.023-0.566,0.035c-8.195,0.574-16.066,2.363-23.453,5.203
		c-0.016,0.008-0.031,0.016-0.047,0.02c-0.723,0.277-1.441,0.566-2.152,0.867c-0.227,0.094-0.45,0.188-0.676,0.285
		c-0.481,0.207-0.961,0.418-1.438,0.633c-0.32,0.144-0.64,0.289-0.961,0.437c-0.082,0.036-0.164,0.079-0.246,0.118
		C46.832,91.793,44.594,92.961,42.41,94.242L42.41,94.242z M83.793,240C46.414,240,16,208.363,16,169.477
		c0-26.36,13.98-49.387,34.633-61.489c0.32-0.187,0.64-0.375,0.965-0.558c0.355-0.2,0.711-0.395,1.07-0.586
		c0.625-0.34,1.258-0.668,1.894-0.985c0.2-0.101,0.403-0.199,0.606-0.297c7.066-3.425,14.676-5.574,22.496-6.316
		c0.07-0.004,0.137-0.012,0.207-0.016c0.926-0.085,1.856-0.152,2.785-0.195c0.11-0.004,0.219-0.008,0.328-0.012
		c0.934-0.043,1.871-0.066,2.813-0.066c0.937,0,1.875,0.023,2.808,0.066c0.11,0.004,0.219,0.008,0.329,0.012
		c0.929,0.043,1.859,0.11,2.785,0.195c0.07,0.004,0.136,0.012,0.207,0.016c7.82,0.742,15.429,2.891,22.496,6.316
		c0.203,0.098,0.406,0.196,0.609,0.297c0.637,0.317,1.266,0.645,1.895,0.985c0.355,0.191,0.711,0.386,1.066,0.586
		c0.324,0.183,0.645,0.371,0.965,0.558c20.652,12.102,34.633,35.129,34.633,61.489C151.59,208.363,121.176,240,83.793,240
		L83.793,240z M83.793,240"/>
                        <path d="M107.398,156.449c0-13.015-10.589-23.609-23.605-23.609c-13.016,0-23.602,10.59-23.602,23.609
		c0,6.656,2.762,12.848,7.473,17.246l-5.66,25.383c-0.125,0.574-0.192,1.156-0.192,1.742c0,6.934,6.793,12.16,15.797,12.16h12.375
		c9.004,0,15.789-5.226,15.789-12.16c0-0.586-0.062-1.168-0.191-1.742l-5.66-25.383
		C104.637,169.297,107.398,163.105,107.398,156.449L107.398,156.449z M78.867,196.98l4.926-22.097l4.93,22.097H78.867z
		 M87.281,163.211c-1.554,0.809-2.754,2.074-3.488,3.562c-0.734-1.488-1.934-2.753-3.488-3.562c-2.535-1.316-4.114-3.91-4.114-6.762
		c0-4.195,3.411-7.609,7.602-7.609c4.195,0,7.605,3.414,7.605,7.609C91.398,159.301,89.82,161.891,87.281,163.211L87.281,163.211z
		 M87.281,163.211"/>
                    </symbol>
                </defs>
            </svg>

            <img class="logoWrap" v-bind:src="`${conf.SETTINGS.APP_URL}static/images/logo.png`" alt="seatup">
            <div class="innerLoginBox">
                <h1>{{ $t('loginTitle') }}</h1>
                <form action="#" method="post" @submit.prevent="submitLogin">
                    <div class="inputWrap">
                        <label for="loginEmail">
                            <svg class="i_email"><use xlink:href="#i_email"></use></svg>
                            <span>{{ $t('email') }}</span>
                        </label>
                        <input type="email" id="loginEmail" name="loginEmail" v-model="email" required>
                    </div>
                    <div class="inputWrap">
                        <label for="loginPassword">
                            <svg class="i_lock"><use xlink:href="#i_lock"></use></svg>
                            <span>{{ $t('password') }}</span>
                        </label>
                        <input type="password" id="loginPassword" name="loginPassword" v-model="password" required>
                    </div>
                    <div class="inputWrap submitWrap">
                        <button>
                            <span>{{ $t('login') }}</span>
                        </button>
                    </div>
                    <router-link to="/login/recover" class="loginBtn">{{ $t('forgotPw') }}</router-link>
                </form>
            </div>
        </div>
</template>

<script>
    import Config from '../Config'
    import KioskLogin from './Kiosk/KioskLogin'
    export default {
        name: 'Login',

        data() {
            return {
                email:'',
                password:'',
                opacity:0,
                conf:Config
            }
        },
        components:{
            KioskLogin,
        },
        methods: {
            submitLogin(e){
                this.$store.dispatch('makeLogin', {email:$("#loginEmail").val(),password:$("#loginPassword").val()})
                    .then(response => {
                        this.$router.push('/')
                    })
                    .catch(response => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('invalidLogin'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            }
        },

        created(){
            let self = this;
            setTimeout(function () {
                $('.loginBox').fadeIn();
            },700)
        },

        beforeMount(){
            this.$store.dispatch('checkLogin')
                                    .then(response =>{
                                        //success
                                        if(response.status){
                                            if(typeof this.$router.currentRoute.query !=='undefined' && this.$router.currentRoute.query.redirect != ''){
                                                this.$router.push(this.$router.currentRoute.query.redirect)
                                            }else {
                                                this.$router.push('/')
                                            }
                                        }
                                    })
                                    .catch(err => {
                                        //err
                                    })
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*body{
        min-height:calc(100% + 140px)
    }*/

    .loginBox{
        text-align: center;
        max-width: 100%;
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%,-50%);
    }
    .loginBox .logoWrap{
        width:162px;
        margin-bottom:52px;
    }
    .innerLoginBox{
        width:533px;
        max-width:100%;
        padding:70px 110px;
        margin:0 auto;
        background: rgba(41,59,90,0.85);
        position: relative;
    }

    .innerLoginBox h1{
        font-weight:300;
        color:#fff;
        font-size:2.235rem;
        line-height: 2.235rem;
    }
    .innerLoginBox form{
        margin-top:70px;

    }
    .innerLoginBox form svg.i_email{
        fill:#fff;
        width:18px;
        height:14px;
    }
    .innerLoginBox form svg.i_lock{
        fill:#fff;
        width:15px;
        height:23px;
    }
    .loginBtn{
        display:inline-block;
        color:#fff;
        font-size:1rem;
        text-decoration: underline;
        margin-top:30px;

    }
    .loginBtn:hover,
    .loginBtn:focus{
        color:#fff;
    }
    .confirmResetPass{
        position: absolute;
        top:0;
        right:0;
        width:100%;
        height:100%;
        opacity:0;
        z-index: -1;
        color:#fff;
        padding: 70px;
        transition: opacity .4s ease-in-out;
        -moz-transition: opacity .4s ease-in-out;
        -webkit-transition: opacity .4s ease-in-out;
    }
    .confirmResetPass svg.i_send{
        width:92px;
        height:42px;
        fill:#57e1d4;
        margin-bottom: 30px;
        margin-right:30px;
    }
    .fp_header{
        font-size:2.353rem;
        margin-bottom: 30px;
    }
    .fp_txt{
        font-size:1.294rem;
        color:#cdcdcd;
        margin-bottom: 30px;
    }
    .fp_txt2{
        font-weight:700;
        font-size:1.294rem;
    }
    .formSubmitted .confirmResetPass{
        opacity:1;
        z-index: 1;
        transition: opacity .4s ease-in-out;
        -moz-transition: opacity .4s ease-in-out;
        -webkit-transition: opacity .4s ease-in-out;
    }
    .formSubmitted h1,
    .formSubmitted #forgotPassForm{
        opacity:0;
        transition: opacity .4s ease-in-out;
        -moz-transition: opacity .4s ease-in-out;
        -webkit-transition: opacity .4s ease-in-out;

    }
    @media only screen and (max-width:767px){
        .innerLoginBox{padding:50px 70px;}
        .confirmResetPass{padding:50px;}
        body {min-height: 100%;}
        main{padding:50px 70px;}
        .loginBox{max-width:70%;}
        .loginBox .logoWrap{width: 150px;margin-bottom: 40px;}
        .innerLoginBox form{margin-top: 55px;}
    }
    @media only screen and (max-width:599px){

        .loginBox .logoWrap{width:135px;}
        .innerLoginBox, .confirmResetPass{padding:40px 50px;}
        .innerLoginBox h1{font-size: 2.1rem;line-height: 2.1rem;}
        .innerLoginBox form{margin-top: 45px;}


    }
    @media only screen and (max-width:479px){
        main{padding:50px;}
        .loginBox{max-width:85%;}
        main{padding:0;}
        .innerLoginBox, .confirmResetPass{padding: 40px 20px;}
        .innerLoginBox h1{font-size: 1.8rem;line-height: 1.8rem;}
        .loginBox .logoWrap{width:120px;}
        .innerLoginBox form{margin-top: 25px;}
        .confirmResetPass svg.i_send{width: 75px;height: 35px;margin-bottom: 20px;}
        .fp_header{margin-bottom:20px;}
    }
    @media only screen and (max-width:360px) and (max-height:500px){
        body.loginWrap{min-height: calc(100% + 100px);}
    }
    @media only screen and (max-height:750px){
        .innerLoginBox{padding: 30px 75px;width: 440px;}
        .innerLoginBox form{margin-top: 40px;}
        .loginBox .logoWrap{width: 140px;margin-bottom: 30px;}
        .confirmResetPass{padding:45px;}
    }
    @media only screen and (max-width:599px) and (max-height:750px){
        .innerLoginBox, .confirmResetPass{padding: 30px 50px;}
    }
    @media only screen and (max-width:479px) and (max-height:750px){
        .innerLoginBox, .confirmResetPass{padding: 30px 20px;}
        .loginBox .logoWrap{    width: 120px;}
    }
    input{
        direction: ltr;
    }
</style>
